import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setBranchByBusinress } from "../lib/slices/branch";
import { fetchBranchaesbyId } from "../services/Branches";

export const useBranches = () => {
  const [allBranches, setAllBranches] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();
  const [error, setError] = useState(null);
  const { user } = useSelector((state) => state.user);
  console.log(user, "useruseruseruseruser");
  const { branchesByBusiness } = useSelector((state) => state.branchSlices);
  const fetchBranches = async () => {
    if (!user) return;
    let type = null;
    let ids = null;
    if (user?.role == "business") {
      type = "All";
      ids = user?.businessId;
    } else {
      type = "user";
      ids = branchesByBusiness?.map((item) => item?._id);
    }

    try {
      setIsLoading(true);
      const response = await fetchBranchaesbyId(type, ids);
      setIsLoading(false);
      if (response.status === 200 || response.status === 201) {
        setAllBranches(response?.data?.data || []);
        dispatch(setBranchByBusinress(response?.data?.data || []));
        localStorage.setItem("branchIds", JSON.stringify(response?.data?.data));
      } else {
        setError(response.data?.message || "Failed to fetch branches");
      }
    } catch (err) {
      setIsLoading(false);
      setError(err.message || "An error occurred");
    }
  };

  return { allBranches, fetchBranches, error, isLoading };
};
